export default __webpack_public_path__ + "static/media/playstore.ce32d165.png";